<div class="modal-header">
    <h4 class="modal-title">Detalle de Producto</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    </button>
</div>
<div class="modal-body">
    <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs">
        <li [ngbNavItem]="1">
            <a ngbNavLink>Detalles</a>
            <ng-template ngbNavContent>
                <form [formGroup]="form">
                    <div class="row d-flex align-items-center">
                        <div class="mb-3 col-12 col-sm">
                            <label for="nombre">Nombre</label>
                            <input type="text" class="form-control" id="nombre" formControlName="nombre"
                                [ngClass]="{'is-invalid': form.controls['nombre'].errors && form.controls['nombre'].touched}">
                            <div class="invalid-feedback">
                                Debe ingresar un valor en el campo.
                            </div>
                        </div>
                        <div class="mb-3 col-12 col-sm">
                            <label for="codigo_barra">Código de Barras</label>
                            <input type="text" class="form-control" id="codigo_barra" formControlName="codigo_barra"
                                [ngClass]="{'is-invalid': form.controls['codigo_barra'].errors && form.controls['codigo_barra'].touched}">
                            <div class="invalid-feedback">
                                Debe ingresar un valor en el campo.
                            </div>
                        </div>
                        <div class="mb-3 col-12 col-sm">
                            <label for="sku">SKU</label>
                            <input type="text" class="form-control" id="sku" formControlName="sku"
                                [ngClass]="{'is-invalid': form.controls['sku'].errors && form.controls['sku'].touched}">
                            <div class="invalid-feedback">
                                Debe ingresar un valor en el campo.
                            </div>
                        </div>
                    </div>
                    <div class="mb-3 col-12 col-sm">
                        <label for="descripcion">Descripción</label>
                        <textarea class="form-control" id="descripcion" formControlName="descripcion" rows="3"
                            [ngClass]="{'is-invalid': form.controls['descripcion'].errors && form.controls['descripcion'].touched}"></textarea>
                        <div class="invalid-feedback">
                            Debe ingresar un valor en el campo.
                        </div>
                    </div>
                    <div class="row">
                        <div class="mb-3 col-12 col-sm">
                            <label for="precio_venta">Precio de Venta</label>
                            <input type="text" class="form-control" id="precio_venta" formControlName="precio_venta"
                                [ngClass]="{'is-invalid': form.controls['precio_venta'].errors && form.controls['precio_venta'].touched}">
                            <div class="invalid-feedback">
                                Debe ingresar un valor en el campo.
                            </div>
                        </div>
                        <div class="mb-3 col-12 col-sm">
                            <label for="precio_compra">Precio de Compra</label>
                            <input type="text" class="form-control" id="precio_compra" formControlName="precio_compra"
                                [ngClass]="{'is-invalid': form.controls['precio_compra'].errors && form.controls['precio_compra'].touched}">
                            <div class="invalid-feedback">
                                Debe ingresar un valor en el campo.
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <!-- <div class="mb-3 col-12 col-sm">
                            <label for="precio_mayorista">Precio Mayorista</label>
                            <input type="text" class="form-control" id="precio_mayorista"
                                formControlName="precio_mayorista"
                                [ngClass]="{'is-invalid': form.controls['precio_mayorista'].errors && form.controls['precio_mayorista'].touched}">
                            <div class="invalid-feedback">
                                Debe ingresar un valor en el campo.
                            </div>
                        </div> -->
                        <div class="mb-3 col-12 col-sm">
                            <label for="precio_compra">Stock Mínimo</label>
                            <input type="text" class="form-control" id="stock_minimo" formControlName="stock_minimo"
                                [ngClass]="{'is-invalid': form.controls['stock_minimo'].errors && form.controls['stock_minimo'].touched}">
                            <div class="invalid-feedback">
                                Debe ingresar un valor en el campo.
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="mb-3 col-12 col-sm">
                            <label for="categoria_id">Categoría</label>
                            <ng-select [items]="categorias" bindLabel="nombre" bindValue="id"
                                formControlName="categoria_id"
                                [ngClass]="{'is-invalid': form.controls['categoria_id'].errors && form.controls['categoria_id'].touched}">
                            </ng-select>

                            <div class="invalid-feedback">
                                Debe ingresar un valor en el campo.
                            </div>
                        </div>
                        <!-- <div class="mb-3 col-12 col-sm">
                            <label for="moneda">Moneda</label>
                            <ng-select [items]="moneda" bindLabel="name" bindValue="id" formControlName="moneda"
                                [ngClass]="{'is-invalid': form.controls['moneda'].errors && form.controls['moneda'].touched}">
                            </ng-select>
                            <div class="invalid-feedback">
                                Debe ingresar un valor en el campo.
                            </div>

                        </div> -->
                    </div>

                </form>
            </ng-template>
        </li>
        <!-- <li [ngbNavItem]="2">
            <a ngbNavLink>Recetas</a>
            <ng-template ngbNavContent>
                <button class="btn btn-primary my-3" (click)="addReceta()">Agregar Receta</button>
                <kuv-table [items]="tableItems" [columns]="tableColumns" [actions]="tableActions" [useFilter]="false"
                    [usePagination]="false"></kuv-table>
            </ng-template>
        </li> -->
        <li [ngbNavItem]="3">
            <a ngbNavLink>Historial Stocks</a>
            <ng-template ngbNavContent>
                <app-producto-historial></app-producto-historial>
            </ng-template>
        </li>
        <li [ngbNavItem]="4">
            <a ngbNavLink>Stocks</a>
            <ng-template ngbNavContent>
                <app-producto-stocks></app-producto-stocks>
            </ng-template>
        </li>

    </ul>
    <div [ngbNavOutlet]="nav" class="border border-top-0 p-3"></div>

</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss()">Cerrar</button>
</div>